var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export function deepClone(src) {
    if (src === null || typeof src !== 'object') {
        return src;
    }
    if (src instanceof Date) {
        return new Date(src.getTime());
    }
    if (src instanceof RegExp) {
        return new RegExp(src);
    }
    if (Array.isArray(src)) {
        var clone = void 0;
        clone = __spreadArray([], __read(src), false);
        for (var i = 0; i < src.length; i++) {
            clone[i] = deepClone(src[i]);
        }
        return clone;
    }
    if (typeof src === 'object') {
        var proto = Object.getPrototypeOf(src);
        var clone = Object.create(proto);
        for (var key in src) {
            if (Object.prototype.hasOwnProperty.call(src, key)) {
                clone[key] = deepClone(src[key]);
            }
        }
        return clone;
    }
}
